module.exports = __webpack_public_path__ + "static/media/slide1_mobile.e21a7afa.webp";